const POS_SALE_STORAGE_KEY = "sale"

export function saveSaleOnStorage(sale = {}) {
    const string = JSON.stringify(sale)
    window.localStorage.setItem(POS_SALE_STORAGE_KEY, string)
}
export function getSaleFromStorage() {
    let string = window.localStorage.getItem(POS_SALE_STORAGE_KEY)
    if (string) {
        return JSON.parse(string)
    } else {
        return {
            "client": "",
            "client_name": "",
            "discount_value_input": 0,
            "discount_type": "cash",
            "invoice_type": 1,
            "total_amount": 0,
            "discount_value": 0,
            "paid_value": 0,
            "change": 0,
            "status": 1,
            "items": [],
            "payments": []
        }
    }
}

export function updateClientToSale(data = {}, remove = false) {
    const sale = getSaleFromStorage()
    sale["client"] = remove ? "" : data.id
    sale["client_name"] = remove ? "" : data.name
    saveSaleOnStorage(sale)
    return sale
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/helpers.js